<template>
<div style="display:flex;justify-content:center;margin-top:20px">
        <el-pagination background @current-change="currpage" :current-page="nowpage"
        :page-size="20" layout="total,prev, pager, next,jumper" :total="total" />
    </div>
</template>
<script setup>
// 接受父级数据，注册事件
const props = defineProps(['total','nowpage'])
const emits = defineEmits(['page_change'])
//获取当前页
const currpage = (val)=>{
    console.log(val)
    //当前页返回父级
    emits('page_change',val)
}
</script>
<style scoped>
:deep(.is-active){
    background-color: #4F46E5 !important;
}
</style>